export interface CustomerFormState {
  firstName: string;
  lastName: string;
  email: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  username: string;
  password: string;
  confirmPassword: string;
}

export const emptyCustomerForm: CustomerFormState = {
  firstName: '',
  lastName: '',
  email: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  postal_code: '',
  country: 'US',
  username: '',
  password: '',
  confirmPassword: '',
};

export function CustomerForm({
  value,
  onChange,
  disabled,
  showCredentials,
}: {
  value: CustomerFormState;
  onChange: (next: CustomerFormState) => void;
  disabled?: boolean;
  showCredentials?: boolean;
}) {
  const set = (key: keyof CustomerFormState) => (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ ...value, [key]: e.target.value });

  return (
    <div>
      <div className="field-row">
        <div className="field">
          <label htmlFor="firstName">First name</label>
          <input id="firstName" value={value.firstName} onChange={set('firstName')} disabled={disabled} autoComplete="given-name" />
        </div>
        <div className="field">
          <label htmlFor="lastName">Last name</label>
          <input id="lastName" value={value.lastName} onChange={set('lastName')} disabled={disabled} autoComplete="family-name" />
        </div>
      </div>

      <div className="field">
        <label htmlFor="email">Email *</label>
        <input
          id="email"
          type="email"
          required
          value={value.email}
          onChange={set('email')}
          disabled={disabled}
          autoComplete="email"
          placeholder="you@example.com"
        />
      </div>

      <div className="field">
        <label htmlFor="line1">Address</label>
        <input id="line1" value={value.line1} onChange={set('line1')} disabled={disabled} autoComplete="address-line1" placeholder="Street address" />
      </div>
      <div className="field">
        <input
          aria-label="Address line 2"
          value={value.line2}
          onChange={set('line2')}
          disabled={disabled}
          autoComplete="address-line2"
          placeholder="Apt, suite, etc. (optional)"
        />
      </div>

      <div className="field-row-3">
        <div className="field">
          <label htmlFor="city">City</label>
          <input id="city" value={value.city} onChange={set('city')} disabled={disabled} autoComplete="address-level2" />
        </div>
        <div className="field">
          <label htmlFor="state">State</label>
          <input id="state" value={value.state} onChange={set('state')} disabled={disabled} autoComplete="address-level1" />
        </div>
        <div className="field">
          <label htmlFor="postal_code">ZIP</label>
          <input id="postal_code" value={value.postal_code} onChange={set('postal_code')} disabled={disabled} autoComplete="postal-code" />
        </div>
      </div>

      {showCredentials ? (
        <div className="credentials-block">
          <p className="eyebrow" style={{ marginTop: 22 }}>Create your account</p>
          <p className="muted" style={{ marginTop: -4, marginBottom: 4 }}>
            You'll use these to sign in to the Gorilla app.
          </p>
          <div className="field">
            <label htmlFor="username">Username *</label>
            <input
              id="username"
              value={value.username}
              onChange={set('username')}
              disabled={disabled}
              autoComplete="username"
              placeholder="At least 3 characters"
            />
          </div>
          <div className="field-row">
            <div className="field">
              <label htmlFor="password">Password *</label>
              <input
                id="password"
                type="password"
                value={value.password}
                onChange={set('password')}
                disabled={disabled}
                autoComplete="new-password"
                placeholder="At least 8 characters"
              />
            </div>
            <div className="field">
              <label htmlFor="confirmPassword">Confirm password *</label>
              <input
                id="confirmPassword"
                type="password"
                value={value.confirmPassword}
                onChange={set('confirmPassword')}
                disabled={disabled}
                autoComplete="new-password"
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
